module.exports = __webpack_public_path__ + "static/img/zhuanli01.c3c4315.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/zhuanli01.png
// module id = ttl6
// module chunks = 1